// Pure helpers for EventPreview tab semantics.
// Enabled locales = canonical keys present on the title jsonb; pickTitle
// cascades selection → EN → placeholder. Ported from reg-portal
// src/events/EventPreview.helpers.ts — local state only, never the global
// i18n store.

// Canonical locale order. Keeps the tab strip's visual order deterministic
// regardless of the underlying jsonb key insertion order.
export const CANONICAL_LOCALES = ['en', 'zh-Hant', 'zh-Hans'];

// Returns the title value to render:
//   1. title[selectedLocale] if a non-empty string
//   2. title.en if a non-empty string
//   3. '[Event Name]' placeholder
export const pickTitle = (title, selectedLocale) => {
  const selected = title?.[selectedLocale];
  if (typeof selected === 'string' && selected.length > 0) return selected;
  const en = title?.en;
  if (typeof en === 'string' && en.length > 0) return en;
  return '[Event Name]';
};

// Rich text counts as content when any non-whitespace text survives tag
// stripping — an empty <p><br></p> shell is NOT content.
export const hasRichTextContent = (value) => {
  if (typeof value !== 'string') return false;
  return value.replace(/<[^>]*>/g, '').trim().length > 0;
};

// Returns the detailDescription html to render for the selected tab:
//   1. detail[selectedLocale] if it carries content
//   2. detail.en if it carries content (EN fallback — same cascade as pickTitle)
//   3. undefined → the "About this event" section is hidden
export const pickDetailDescription = (detail, selectedLocale) => {
  const selected = detail?.[selectedLocale];
  if (hasRichTextContent(selected)) return selected;
  const en = detail?.en;
  if (hasRichTextContent(en)) return en;
  return undefined;
};
